// ชนิดเหรียญ/แบงก์ที่นับในลิ้นชัก — ต้องตรงกับ services/api/src/utils/cashDrawer.js
// (monorepo นี้ไม่มี shared package จึงประกาศซ้ำสองฝั่ง; server ปฏิเสธชนิดที่ไม่รู้จักอยู่แล้ว)
export const DENOMINATIONS = [
  { value: 1, kind: 'coin' },
  { value: 2, kind: 'coin' },
  { value: 5, kind: 'coin' },
  { value: 10, kind: 'coin' },
  { value: 20, kind: 'note' },
  { value: 50, kind: 'note' },
  { value: 100, kind: 'note' },
  { value: 500, kind: 'note' },
  { value: 1000, kind: 'note' },
];

export const emptyCounts = () => Object.fromEntries(DENOMINATIONS.map(d => [String(d.value), '']));

/** counts อาจเป็นสตริง (ช่องกรอก) หรือตัวเลข (จาก server) — ว่าง/ไม่ใช่ตัวเลข นับเป็น 0 */
export const countOf = (counts, value) => {
  const n = Number(counts?.[String(value)]);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
};

export const sumCounts = (counts) =>
  DENOMINATIONS.reduce((sum, d) => sum + countOf(counts, d.value) * d.value, 0);

export const hasAnyCount = (counts) => DENOMINATIONS.some(d => countOf(counts, d.value) > 0);

export const denominationLabel = (d) => `${d.kind === 'coin' ? 'เหรียญ' : 'แบงก์'} ${d.value}`;

/** ตัวเลขเงิน: มีทศนิยมเฉพาะเมื่อมีจริง */
export const formatBaht = (n) =>
  (Number(n) || 0).toLocaleString('th-TH', { maximumFractionDigits: 2 });

/**
 * ทอนเงินด้วยแบงก์/เหรียญใหญ่สุดก่อนเสมอ (greedy) — ใช้ได้ผลลัพธ์เหมาะสมที่สุดเสมอกับชุดเงินไทย
 * (1,2,5,10,20,50,100,500,1000) เพราะเป็นระบบ canonical เหมือนเงิน USD ไม่ใช่ทอนไม่ได้แบบชุดเงินแปลกๆ
 * ใช้เป็น "ค่าเริ่มต้นที่แนะนำ" ให้พนักงานแก้ไขต่อได้ ไม่ใช่บังคับว่าต้องทอนตามนี้เป๊ะ
 * (ลิ้นชักจริงอาจไม่มีแบงก์ย่อยพอ พนักงานปรับเป็นชนิดอื่นแทนได้)
 */
export const breakdownChange = (amount, available = null) => {
  const run = (cap) => {
    let remaining = Math.round((Number(amount) || 0) * 100) / 100;
    const counts = emptyCounts();
    if (remaining <= 0) return { counts, remaining: 0 };
    for (let i = DENOMINATIONS.length - 1; i >= 0; i--) {
      const value = DENOMINATIONS[i].value;
      let n = Math.floor(remaining / value + 1e-9);
      if (cap) n = Math.min(n, Math.max(0, Math.floor(Number(cap[String(value)]) || 0)));
      if (n > 0) {
        counts[String(value)] = String(n);
        remaining = Math.round((remaining - n * value) * 100) / 100;
      }
    }
    return { counts, remaining };
  };
  // available = จำนวนที่มีจริงในลิ้นชักต่อชนิด (null = ไม่รู้ ไม่จำกัด) ทอนเฉพาะชนิดที่มีอยู่ก่อน
  // ถ้าของในลิ้นชักไม่พอทอนให้ครบ (หรือข้อมูลลิ้นชักคลาดเคลื่อน) ถอยกลับไปใช้แบบไม่จำกัดเหมือนเดิม
  // แทนที่จะปล่อยให้ทอนไม่ครบ ไม่งั้นพนักงานปิดบิลไม่ได้
  if (available) {
    const capped = run(available);
    if (capped.remaining <= 0.001) return capped.counts;
  }
  return run(null).counts;
};

/**
 * ไอคอนต่อชนิดเงิน (swatch สี ไม่ใช่รูปถ่ายจริง — โปรเจกต์นี้ไม่มีรูปธนบัตร/เหรียญจริงและไม่ได้
 * ติดตั้ง icon library ใดๆ) โทนสีอิงจากธนบัตร/เหรียญไทยจริงเพื่อให้จำง่ายตอนกวาดตาหาแบงก์
 * shape: 'note' = สี่เหลี่ยมมุมโค้ง, 'coin' = วงกลม — ใช้ใน CashDenominationInput.jsx เท่านั้น
 */
export const DENOMINATION_STYLE = {
  1000: { shape: 'note', color: '#8b7355', textColor: '#fff' },
  500: { shape: 'note', color: '#8b5cf6', textColor: '#fff' },
  100: { shape: 'note', color: '#dc2626', textColor: '#fff' },
  50: { shape: 'note', color: '#2563eb', textColor: '#fff' },
  20: { shape: 'note', color: '#16a34a', textColor: '#fff' },
  10: { shape: 'coin', color: '#c9a227', textColor: '#fff' },
  5: { shape: 'coin', color: '#9ca3af', textColor: '#fff' },
  2: { shape: 'coin', color: '#b8860b', textColor: '#fff' },
  1: { shape: 'coin', color: '#d1d5db', textColor: '#374151' },
};
